import './PublicOrderRequestInfoContent.scss';

import { isHtml, sanitizeHtml } from 'helpers/htmlHelpers';

interface Props {
  content: string;
}

const PublicOrderRequestInfoContent = ({ content }: Props) => {
  if (!isHtml(content)) {
    return <div className="PublicOrderRequestInfoContent plaintext">{content}</div>;
  }

  const html = sanitizeHtml(content);

  return (
    // HTML is sanitized above; never pass the raw company content to this element.
    // eslint-disable-next-line react/no-danger
    <div className="PublicOrderRequestInfoContent" dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default PublicOrderRequestInfoContent;
